import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SlaExpandedDetailGrid,
  type SlaExpandedDetailItem,
} from '~/app/landing/sla/shared/components/SlaExpandedDetailGrid';
import { formatDateLabel } from '~/app/landing/sla/shared/utils/sla-format.utils';
import type { MaintenancePartnershipValidity } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';

export interface MaintenanceSlaPartnershipValidityProps {
  partnership: MaintenancePartnershipValidity;
}

export function MaintenanceSlaPartnershipValidity({
  partnership,
}: MaintenanceSlaPartnershipValidityProps) {
  const { t } = useTranslation('sla');
  const items = useMemo<SlaExpandedDetailItem[]>(
    () => [
      {
        key: 'validFrom',
        label: t('oems.maintenance.fields.validFrom'),
        value: formatDateLabel(partnership.validFrom),
      },
      {
        key: 'validTo',
        label: t('oems.maintenance.fields.validTo'),
        value: partnership.validTo
          ? formatDateLabel(partnership.validTo)
          : t('review.openEnded'),
      },
    ],
    [partnership, t],
  );

  return <SlaExpandedDetailGrid items={items} />;
}
